/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLeasingContractDto } from '../../models/backend-leasing-contract-dto';

export interface FinancingSourcesLeasingsList$Params {
  /**
   * * `3` - Не облагается
   * * `1` - Экспортная ставка
   * * `2` - Льготная ставка
   * * `0` - Основная ставка
   * * `4` - Ставка продаж физ. лицам
   * * `5` - Ставка продаж юр. лицам
   */
  VAT_rate?: 0 | 1 | 2 | 3 | 4 | 5;
  capex?: number;
  contract_start_date?: string;
  create_date?: string;
  distribution_redemption_switch?: boolean;
  initial_payment?: number;
  is_blocked?: boolean;
  lessor?: string;
  monthly_lease_payment?: number;
  name?: string;
  redemption_sum_general?: number;
  term_leasing_contract?: number;
  variant?: number;
}

export function financingSourcesLeasingsList(
  http: HttpClient,
  rootUrl: string,
  params?: FinancingSourcesLeasingsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendLeasingContractDto>>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesLeasingsList.PATH, 'get');
  if (params) {
    rb.query('VAT_rate', params.VAT_rate, {});
    rb.query('capex', params.capex, {});
    rb.query('contract_start_date', params.contract_start_date, {});
    rb.query('create_date', params.create_date, {});
    rb.query('distribution_redemption_switch', params.distribution_redemption_switch, {});
    rb.query('initial_payment', params.initial_payment, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('lessor', params.lessor, {});
    rb.query('monthly_lease_payment', params.monthly_lease_payment, {});
    rb.query('name', params.name, {});
    rb.query('redemption_sum_general', params.redemption_sum_general, {});
    rb.query('term_leasing_contract', params.term_leasing_contract, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendLeasingContractDto>>;
    }),
  );
}

financingSourcesLeasingsList.PATH = '/api/financing_sources/leasings/';
